<div class="k-overlay" *ngIf="editFormActive"></div>
<kendo-window #settingEditWindow *ngIf="editFormActive" (close)="closeEditForm()" [width]="800"
  style="position:fixed;min-height:500px" [(height)]="editWindowHeightPx" [top]="250"
  (stateChange)="onSettingEditWindowStateChange($event)" (resizeEnd)="syncEditWindowHeightFromWindow()">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{ 'SETTING-EDIT' | translate }}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <form novalidate [formGroup]="editForm" class="k-form" style="padding:0!important;margin-top:-8px;">
    <kendo-tabstrip #tabstrip>
      <kendo-tabstrip-tab title="{{ 'SETTING-SYSTEM' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="row m-2" *ngIf="valueType !== 'boolean'">
            <div class="col-12">
              <label class="k-form-field">
                <span class="k-text-uppercase dark">
                  {{'NAME' | translate}}
                </span>
                <span class="font-weight-bold ml-4">{{name.value}}</span>
              </label>
            </div>
          </div>
          <div class="row m-2">
            <div class="col-12">
              <label class="k-form-field">
                <div [ngSwitch]="valueType">
                  <div *ngSwitchCase="'int'" class="w-100">
                    <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="intSettingValueMax" [decimals]="0"
                      [autoCorrect]="false" (valueChange)="onIntSettingNumericValueChange(value)" class="w-25">
                    </kendo-numerictextbox>
                    <!--Info for DisableAccountsDays-->
                    <span
                      *ngIf="settingKey === 'DisableAccountsNonOperatorsDays' || settingKey === 'DisableAccountsOperatorsDays'"
                      style="display: inline-flex">
                      <div #tipD kendoTooltip position="right" class="ml-2 keyboard-accessible" tabindex="0"
                        showOn="none" (focus)="showTooltip(disableAccounts,tipD)" aria-live="polite"
                        (mouseover)="showTooltip(disableAccounts,tipD)" (blur)="hideTooltip(tipD)"
                        (mouseout)="hideTooltip(tipD)">
                        <a #disableAccounts title="{{'SETTING-DISABLE-ACCOUNT-DAYS-INFO' | translate}}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </div>
                  <div formArrayName="recordContactFields" style="height: 450px"
                    *ngSwitchCase="'recordContactFieldsSetting'">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>
                            <label class="control-label font-weight-normal">{{ 'FIELD-NAME' | translate }}
                            </label>
                          </th>
                          <th class="text-center">
                            <label class="control-label font-weight-normal">{{ 'FIELD-VISIBLE' | translate }}
                            </label>
                          </th>
                          <th class="text-center">
                            <label class="control-label font-weight-normal">{{ 'FIELD-REQUIRED' | translate }}
                            </label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let contact of editForm.controls.recordContactFields.controls; let i=index;"
                          [formGroupName]="i">
                          <td class="font-weight-bold" style="width:60%">
                            <span> {{editForm.controls.recordContactFields.controls[i].controls.name.value}}
                            </span>
                          </td>
                          <td class="text-center">
                            <kendo-switch formControlName="valueVisible" onLabel="{{'YES' | translate }}"
                              offLabel="{{'NO' | translate }}">
                            </kendo-switch>
                          </td>
                          <td class="text-center">
                            <kendo-switch formControlName="valueRequired" onLabel="{{'YES' | translate }}"
                              offLabel="{{'NO' | translate }}">
                            </kendo-switch>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div *ngSwitchCase="'linkTokenExpiration'" class="w-100">
                    <div class="row">
                      <div class="col-3">
                        <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="intSettingValueMax" [decimals]="0"
                          [autoCorrect]="false" (valueChange)="onIntSettingNumericValueChange(value)" class="w-75">
                        </kendo-numerictextbox>
                      </div>
                      <div class="col-3">
                        <kendo-dropdownlist formControlName="captureLinkTokenExpirationUnit" style="margin-left:-30px"
                          [data]="captureLinkTokenExpirationUnits" [textField]="'text'" [valueField]="'value'"
                          [valuePrimitive]="true">
                        </kendo-dropdownlist>
                      </div>
                    </div>
                  </div>
                  <div *ngSwitchCase="'optInTokenExpiration'" class="w-100">
                    <div class="row">
                      <div class="col-3">
                        <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="intSettingValueMax" [decimals]="0"
                          [autoCorrect]="false" (valueChange)="onIntSettingNumericValueChange(value)" class="w-75">
                        </kendo-numerictextbox>
                      </div>
                      <div class="col-3">
                        <kendo-dropdownlist formControlName="optInTokenExpirationUnit" style="margin-left:-30px"
                          [data]="optInTokenExpirationUnits" [textField]="'text'" [valueField]="'value'"
                          [valuePrimitive]="true">
                        </kendo-dropdownlist>
                      </div>
                    </div>
                  </div>
                  <div *ngSwitchCase="'consentExpirationPolicy'" class="w-100">
                    <!-- default -->
                    <div class="row">
                      <div class="col-3" style="padding-top: 7px;">
                        <label class="k-text-uppercase dark font-weight-normal">{{ 'DEFAULT' | translate }} </label>
                      </div>
                      <div class="col-3">
                        <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="intSettingValueMax" [decimals]="0"
                          [autoCorrect]="false" (valueChange)="onIntSettingNumericValueChange(value)" class="w-75">
                        </kendo-numerictextbox>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                          *ngIf="value.hasError('max') && (value.dirty || value.touched)">
                          {{ 'SETTING-VALUE-INT-MAX' | translate: { max: intSettingValueMax } }}
                        </div>
                      </div>
                      <div class="col-3">
                        <kendo-dropdownlist formControlName="consentExpirationPolicyUnit"
                          [data]="consentExpirationPolicyUnits" [textField]="'text'" [valueField]="'value'"
                          [valuePrimitive]="true">
                        </kendo-dropdownlist>
                      </div>
                      <div class="col-3">
                        <button kendoButton [primary]="true" (click)="addConsentExpirationPolicy()" type="button"
                          class="mb-2">
                          {{'ADD' | translate}}<i class="far fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <!-- additional -->
                    <div formArrayName="consentExpirationPolicies" class="container-organizations"
                      style="max-height: 185px;">
                      <table class="table table-hover" style="margin-left:-10px">
                        <thead>
                          <tr>
                            <th style="width:28%">
                              <label class="k-text-uppercase dark font-weight-normal">{{ 'TYPE' | translate }} *
                              </label>
                            </th>
                            <th style="width:28%">
                              <label class="k-text-uppercase dark font-weight-normal">{{ 'VALUE' | translate }} *
                              </label>
                            </th>
                            <th style="width:44%">
                              <label class="k-text-uppercase dark font-weight-normal">{{ 'UNIT' | translate }} *
                              </label>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let option of editForm.controls.consentExpirationPolicies.controls; let i=index"
                            [formGroupName]="i">
                            <td style="width:28%">
                              <kendo-combobox [data]="consentTypes" [textField]="'displayName'" [valueField]="'id'"
                                formControlName="consentType">
                              </kendo-combobox>
                              <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="editForm.controls.consentExpirationPolicies.controls[i].controls.consentType.hasError('required') && 
                                                                     editForm.controls.consentExpirationPolicies.controls[i].controls.consentType.touched">
                                {{ 'REQUIRED-TYPE' | translate }}
                              </div>
                            </td>
                            <td style="width:28%">
                              <kendo-numerictextbox [format]="'n0'" formControlName="consentExpirationPolicyValue"
                                [min]="0" [max]="intSettingValueMax" [decimals]="0" [autoCorrect]="false"
                                (valueChange)="onIntSettingNumericValueChange(editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue)"
                                class="w-75" style="margin-left:-1px;width:120px">
                              </kendo-numerictextbox>
                              <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue.hasError('required') &&
                                                                     editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue.touched">
                                {{ 'REQUIRED-VALUE' | translate }}
                              </div>
                              <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue.hasError('max') &&
                                                                     (editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue.dirty ||
                                                                      editForm.controls.consentExpirationPolicies.controls[i].controls.consentExpirationPolicyValue.touched)">
                                {{ 'SETTING-VALUE-INT-MAX' | translate: { max: intSettingValueMax } }}
                              </div>
                            </td>
                            <td style="width:44%">
                              <kendo-dropdownlist formControlName="unit" [data]="consentExpirationPolicyUnits"
                                style="width:60%" [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true">
                              </kendo-dropdownlist>
                              <div class="k-tooltip k-tooltip-validation" role="alert" style="width:40%"
                                *ngIf="editForm.controls.consentExpirationPolicies.controls[i].controls.unit.hasError('required') && 
                                                                     editForm.controls.consentExpirationPolicies.controls[i].controls.unit.touched">
                                {{ 'REQUIRED-UNIT' | translate }}
                              </div>
                            </td>
                            <td>
                              <a *ngIf="!isReadOnly" title="{{ 'DELETE' | translate }}"
                                (click)="removeConsentExpirationPolicy(i,editForm.controls.consentExpirationPolicies.controls[i].controls.id.value)">
                                <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div *ngSwitchCase="'clientHeaderFields'">
                    <div class="fields-container">
                      <div class="listbox-wrapper">
                        <h4 class="text-center">{{'AVAILABLE' | translate}}</h4>
                        <kendo-listbox kendoListBoxDataBinding [data]="clientHeaderFields"
                          [connectedWith]="chosenListBox" [toolbar]="clientBannerListboxToolbar" selectable="multiple"
                          [style.height.px]="clientHeaderListboxHeight" textField="text" valueField="value"
                          (action)="onClientBannerListboxAction()">
                        </kendo-listbox>
                      </div>
                      <div class="listbox-wrapper">
                        <h4 class="text-center">{{'SELECTED' | translate}}</h4>
                        <kendo-listbox #chosenListBox [data]="chosenClientFields" [toolbar]="false"
                          selectable="multiple" [style.height.px]="clientHeaderListboxHeight" textField="text"
                          valueField="value" (action)="onClientBannerListboxAction()">
                        </kendo-listbox>
                      </div>
                    </div>
                  </div>
                  <div *ngSwitchCase="'assessmentsMulti'">
                    <kendo-multiselect [data]="formAssessments" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'name'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'assessments'">
                    <kendo-combobox formControlName="value" [data]="formAssessments" [textField]="'name'"
                      [valueField]="'id'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'channels'">
                    <kendo-combobox formControlName="value" [data]="groupedChannels" [textField]="'name'"
                      [valueField]="'id'" [itemDisabled]="channelItemDisabled" [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'referralChannelsMulti'">
                    <kendo-multiselect [data]="groupedReferralChannels" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'name'" [valueField]="'id'" [filterable]="true"
                      (filterChange)="filterReferralChannels($event)" (close)="referralChannelSearchTerm=''">
                      <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.name | highlight : referralChannelSearchTerm }}">
                        </span>
                      </ng-template>
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'sendInviteTemplate'">
                    <kendo-multicolumncombobox formControlName="value" [data]="sendInviteTemplates" [textField]="'name'"
                      [valueField]="'id'" [valuePrimitive]="true">
                      <kendo-combobox-column [field]="'name'" title="{{'NAME' | translate}}" [width]="150">
                      </kendo-combobox-column>
                      <kendo-combobox-column [field]="'mimeType'" title="{{'EMAIL-TEMPLATE-MIME-TYPE' | translate}}"
                        [width]="80">
                      </kendo-combobox-column>
                      <kendo-combobox-column [field]="'language'" title="{{'EMAIL-TEMPLATE-LANGUAGE' | translate}}"
                        [width]="50">
                      </kendo-combobox-column>
                    </kendo-multicolumncombobox>
                  </div>
                  <div *ngSwitchCase="'emailContentType'">
                    <kendo-combobox formControlName="value" [data]="emailContentTypeTexts" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'consentModel'">
                    <kendo-combobox formControlName="value" [data]="consentModels" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true" class="w-50">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'communityDefaultLandingPage'">
                    <kendo-combobox formControlName="value" [data]="communityDefaultLandingPage" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true" class="w-50">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'payerBillingIdentifier'">
                    <kendo-multiselect [data]="communityServiceIdentifierTypes" [valuePrimitive]="true"
                      formControlName="value" [textField]="'displayName'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'day'">
                    <kendo-combobox formControlName="value" [data]="days" [textField]="'text'" [valueField]="'value'"
                      [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'distance'">
                    <kendo-combobox formControlName="value" [data]="providerDistances" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'latitudeLongitude'">
                    <div class="w-100">
                      <kendo-numerictextbox [format]="'n7'" formControlName="latitude" [decimals]="7" class="w-25">
                      </kendo-numerictextbox>
                    </div>
                    <div class="w-100">
                      <kendo-numerictextbox [format]="'n7'" formControlName="longitude" [decimals]="7"
                        class="mt-2 w-25">
                      </kendo-numerictextbox>
                    </div>
                  </div>
                  <div *ngSwitchCase="'language'">
                    <kendo-combobox formControlName="value" [data]="languages" [textField]="'text'"
                      [valueField]="'value'" [valuePrimitive]="true">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'loginLanguages'">
                    <kendo-multiselect [data]="loginLanguages" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'image'">
                    <input kendoTextBox formControlName="value" class="w-100" />
                    <input class="d-none" type="file" (change)="onFileChanged($event)" #fileInput />
                    <button kendoButton type="button" (click)="fileInput.click()" class="mt-3 float-right">
                      {{'SELECT-LOGO' | translate}}<i class="far fa-image"></i>
                    </button> <i *ngIf="imagePreview" class="fas fa-trash-alt fa-lg mr-3 float-right"
                      style="margin-top:30px" title="{{'DELETE' | translate}}" (click)="deleteImage()">
                    </i>
                    <!--Image preview-->
                    <img [src]="imagePreview" class="mt-2" style="width: auto; max-height: 80px;">
                  </div>
                  <div *ngSwitchCase="'roles'">
                    <kendo-multiselect [data]="roles" [valuePrimitive]="true" formControlName="value"
                      [textField]="'text'" [valueField]="'value'" [itemDisabled]="roleItemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'demographics'">
                    <kendo-multiselect [data]="demographics" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'"
                      [itemDisabled]="demographicItemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'recommendedDemographics'">
                    <kendo-multiselect [data]="recommendedDemographics" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'configurableDashboard'">
                    <kendo-multiselect [data]="configurableDashboard" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'communityResources'">
                    <kendo-multiselect [data]="communityResources" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'"
                      [itemDisabled]="communityResourceItemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'insuranceFields'">
                    <kendo-multiselect [data]="insuranceFields" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'"
                      [itemDisabled]="insuranceFieldItemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'searchableCommunityResources'">
                    <kendo-multiselect [data]="searchableCommunityResources" [valuePrimitive]="true" [autoClose]="true"
                      formControlName="value" [textField]="'text'" [valueField]="'value'"
                      [itemDisabled]="searchableCommunityResourceItemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'programLeads'">
                    <kendo-multiselect [data]="programLeadsAndProgramSupportUsers" [valuePrimitive]="true"
                      formControlName="value" [textField]="'fullName'" [valueField]="'id'"
                      [itemDisabled]="itemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'users'">
                    <kendo-multiselect [data]="allUsers" [valuePrimitive]="true" formControlName="value"
                      [textField]="'fullName'" [valueField]="'id'" [itemDisabled]="itemDisabled">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'schedulerViews'">
                    <kendo-multiselect [data]="schedulerViews" [valuePrimitive]="true" formControlName="value"
                      [textField]="'text'" [valueField]="'value'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'subjectIdentifiers'">
                    <kendo-multiselect [data]="subjectIdentifiers" [valuePrimitive]="true" formControlName="value"
                      [textField]="'displayName'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'resourceStatuses'">
                    <kendo-multiselect [data]="resourceStatuses" [valuePrimitive]="true" formControlName="value"
                      [textField]="'displayName'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'goalCodeSet'">
                    <kendo-combobox [data]="goalCodeSet" [valuePrimitive]="true" formControlName="value"
                      [textField]="'name'" [valueField]="'id'">
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'teamRoles'">
                    <kendo-combobox id="role" formControlName="value" class="w-50" [valuePrimitive]="true"
                      [data]="teamRolesFiltered" [textField]="'name'" [valueField]="'id'" [filterable]="true"
                      (filterChange)="filterTeamRoles($event)" (close)="searchTerm=''"
                      [itemDisabled]="roleItemDisabled">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                        </span>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                  <div *ngSwitchCase="'teamRolesMulti'">
                    <kendo-multiselect [data]="teamRolesFiltered" [valuePrimitive]="true" formControlName="value"
                      [textField]="'name'" [valueField]="'id'" [filterable]="true"
                      (filterChange)="filterTeamRoles($event)" (close)="searchTerm=''" [autoClose]="true"
                      [itemDisabled]="roleItemDisabled">
                      <ng-template kendoMultiSelectItemTemplate let-dataItem>
                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                        </span>
                      </ng-template>
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'priority'">
                    <kendo-multiselect [data]="listPriorities" [valuePrimitive]="true" formControlName="value"
                      [textField]="'text'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'boolean'">
                    <input id="boolean" type="checkbox" formControlName="value" kendoCheckBox />
                    <label class="k-checkbox-label" for="boolean">{{name.value}}</label>
                  </div>
                  <div *ngSwitchCase="'textarea'">
                    <textarea kendoTextArea class="w-100 k-textarea" rows="4" formControlName="value" maxlength="1024">
                    </textarea>
                  </div>
                  <div *ngSwitchCase="'consentTypes'">
                    <kendo-multiselect [data]="consentTypes" [valuePrimitive]="true" formControlName="value"
                      [textField]="'displayName'" [valueField]="'id'">
                    </kendo-multiselect>
                  </div>
                  <div *ngSwitchCase="'gridFilter'">
                    <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
                      [pageable]="{ buttonCount: 5, pageSizes: pageSizes}" [pageSize]="view.state.take"
                      [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort" [filterable]="false"
                      [filter]="view.state.filter" [columnMenu]="true" [resizable]="true" [reorderable]="true"
                      (dataStateChange)="dataStateChange($event)" (pageChange)="pageChange($event)"
                      (columnVisibilityChange)="onVisibilityChange($event)" (columnResize)="onResize($event)"
                      (columnReorder)="onReorder($event)">
                      <kendo-grid-messages noRecords="{{ 'GRID-NO-DATA' | translate }}">
                      </kendo-grid-messages>
                      <kendo-grid-column *ngFor="let col of view.columnsConfig" [field]="col.field" [title]="col.title"
                        [width]="col.width" [filter]="col.filter" [format]="col.format" [filterable]="col.filterable"
                        [sortable]="col.sortable" [hidden]="col.hidden !== undefined ? col.hidden : false">
                      </kendo-grid-column>
                    </kendo-grid>
                  </div>
                  <div *ngSwitchDefault>
                    <input class="w-100" id="value" kendoTextBox formControlName="value" maxlength="255" />
                  </div>
                </div>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="value.hasError('required') && value.touched">
                  {{'SETTING-REQUIRED-VALUE' | translate}}
                </div>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="value.hasError('missingMin') && value.touched">
                  {{ 'SETTING-MISSING-$MIN' | translate }}
                </div>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="value.hasError('missingMax') && value.touched">
                  {{ 'SETTING-MISSING-$MAX' | translate }}
                </div>
                <div class="k-tooltip k-tooltip-validation" role="alert"
                  *ngIf="value.hasError('max') && (value.dirty || value.touched) && valueType !== 'consentExpirationPolicy'">
                  {{ 'SETTING-VALUE-INT-MAX' | translate: { max: intSettingValueMax } }}
                </div>
              </label>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'SETTING-ORGANIZATION' | translate }}" *ngIf="enabledOrganizationsTab">
        <ng-template kendoTabContent>
          <button kendoButton [primary]="true" (click)="addOrganization()" type="button" class="mb-2">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
          </button>
          <div formArrayName="organizations" class="container-organizations">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>
                    <label class="control-label text-uppercase font-weight-normal">{{ 'ORGANIZATION' | translate }}
                      *</label>
                  </th>
                  <th>
                    <label class="control-label text-uppercase font-weight-normal">{{ 'VALUE' | translate }} *</label>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let organization of editForm.controls.organizations.controls; let i=index"
                  [formGroupName]="i">
                  <td style="width:40%">
                    <kendo-combobox class="w-100" formControlName="organization" [data]="organizations"
                      [textField]="'name'" [valueField]="'id'" [valuePrimitive]="false" [itemDisabled]="itemInactive">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls.organizations.controls[i].controls.organization.hasError('required') && 
                                                          editForm.controls.organizations.controls[i].controls.organization.touched">
                      {{ 'REQUIRED-ORGANIZATION' | translate }}
                    </div>
                  </td>
                  <td style="width:50%">
                    <div [ngSwitch]="valueType">
                      <div *ngSwitchCase="'int'">
                        <kendo-numerictextbox [format]="'n0'" formControlName="value" [min]="0" [max]="intSettingValueMax" [decimals]="0"
                          [autoCorrect]="false"
                          (valueChange)="onIntSettingNumericValueChange(editForm.controls.organizations.controls[i].controls.value)">
                        </kendo-numerictextbox>
                      </div>
                      <div *ngSwitchCase="'emailContentType'">
                        <kendo-combobox formControlName="value" [data]="emailContentTypeTexts" [textField]="'text'"
                          [valueField]="'value'" [valuePrimitive]="true">
                        </kendo-combobox>
                      </div>
                      <div *ngSwitchCase="'subjectIdentifiers'">
                        <kendo-multiselect [data]="subjectIdentifiers" [valuePrimitive]="true" formControlName="value"
                          [textField]="'displayName'" [valueField]="'id'">
                        </kendo-multiselect>
                      </div>
                      <div *ngSwitchCase="'assessmentsMulti'">
                        <kendo-multiselect [data]="formAssessments" [valuePrimitive]="true" [autoClose]="true"
                          formControlName="value" [textField]="'name'" [valueField]="'id'">
                        </kendo-multiselect>
                      </div>
                      <div *ngSwitchCase="'referralChannelsMulti'">
                        <kendo-multiselect [data]="groupedReferralChannels" [valuePrimitive]="true" [autoClose]="true"
                          formControlName="value" [textField]="'name'" [valueField]="'id'" [filterable]="true"
                          (filterChange)="filterReferralChannels($event)" (close)="referralChannelSearchTerm=''">
                          <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : referralChannelSearchTerm }}">
                            </span>
                          </ng-template>
                        </kendo-multiselect>
                      </div>
                      <div *ngSwitchDefault>
                        <input class="w-100" id="value" kendoTextBox formControlName="value" maxlength="255" />
                      </div>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls.organizations.controls[i].controls.value.hasError('required') &&
                                                          editForm.controls.organizations.controls[i].controls.value.touched">
                      {{ 'SETTING-REQUIRED-VALUE' | translate }}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="editForm.controls.organizations.controls[i].controls.value.hasError('max') &&
                                                          (editForm.controls.organizations.controls[i].controls.value.dirty ||
                                                           editForm.controls.organizations.controls[i].controls.value.touched)">
                      {{ 'SETTING-VALUE-INT-MAX' | translate: { max: intSettingValueMax } }}
                    </div>
                  </td>
                  <td>
                    <a title="{{ 'DELETE' | translate }}"
                      (click)="removeOrganization(i,editForm.controls.organizations.controls[i].controls.id.value)">
                      <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px;bottom:0" class="w-100 mt-3">
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <button class=" k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onSave($event)">{{ 'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-window>